const apply = (translation: string, params?: Record<string, any>) => {
  if (!params) return translation

  return Object.entries(params).reduce(
    (acc, [key, value]) =>
      acc.replace(new RegExp(`{{${key}}}`, 'g'), String(value)),
    translation,
  )
}

export default apply
